import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import './index.scss';
import { getDocumentTypeRules } from "../../../../context/actions/document";
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { Input, Button } from 'reactstrap';
import { useIdleTimer } from 'react-idle-timer';
import { useContext } from 'react';
import { SocketContext } from '../../../../context/actions/socket';
import DocAssistWindowManager from '../../DocAssistWindowManager'; // Import the window manager

const DocAssistRules = ({ }) => {
	const { socket, backendSocket } = useContext(SocketContext);
	const location = useLocation();
	const history = useHistory();
	const { packetId: initialPacketId, orgId } = queryString.parse(location.search);
	const [packetId, setPacketId] = useState(initialPacketId);

	const [orgRules, setOrgRules] = useState([]);
	const [generalRules, setGeneralRules] = useState([]);
	const [orgName, setOrgName] = useState('');
	const [docTypeName, setDocTypeName] = useState('');
	const [loader, setLoader] = useState(false);
	const dispatch = useDispatch();
	let [payload, setPayload] = useState({ organization: orgId, docType: packetId });
	const user = useSelector((state) => state.user.user);
	const [searchQuery, setSearchQuery] = useState('');

	// Initialize the window manager
	useEffect(() => {
		DocAssistWindowManager.init();
		
		// When this component unloads, make sure to update localStorage
		return () => {
			// This ensures localStorage is cleaned up when a docAssist window is closed
			if (window.name === 'docAssistRules') {
				localStorage.removeItem(DocAssistWindowManager.WINDOW_KEY);
			}
		};
	}, []);

	const onIdle = () => {
		// Update localStorage before closing
		localStorage.removeItem(DocAssistWindowManager.WINDOW_KEY);
		window.close();
	}

	useIdleTimer({
		timeout: 1000 * 60 * 15,
		onIdle,
		crossTab: true
	})
	
	useEffect(() => {
		if(user.loggedIn == false){
			localStorage.removeItem(DocAssistWindowManager.WINDOW_KEY);
			window.close();
		}
	}, [user]);

	const updatePacketId = (newPacketId) => {
		const params = { packetId: newPacketId, orgId }; // Keep orgId unchanged
		history.push({
			pathname: location.pathname,
			search: queryString.stringify(params),
		});
	};
	const updateOrgId = (newOrgId) => {
		const params = { packetId, orgId: newOrgId }; // Keep orgId unchanged
		history.push({
			pathname: location.pathname,
			search: queryString.stringify(params),
		});
	};

	// Listen for window messages
	useEffect(() => {
		const handleMessage = (event) => {
			// Validate origin for security
			// const allowedOrigins = [
			// 	'http://20.25.118.115:4200',
			// 	// Add other trusted origins if needed
			// ];
			
			// // Skip if origin is not allowed and not same origin
			// if (!allowedOrigins.includes(event.origin) && event.origin !== window.location.origin) {
			// 	return;
			// }
			
			const { action, data } = event.data || {};
			
			if (action === 'UPDATE_DOCASSIST' && data) {
				// Update the parameters and fetch new rules
				if (data.packetId && data.orgId) {
					setPacketId(data.packetId);
					const updatedPayload = { organization: data.orgId, docType: data.packetId };
					setPayload(updatedPayload);
					fetchRules(updatedPayload);
					
					// Update URL
					const params = { packetId: data.packetId, orgId: data.orgId };
					history.push({
						pathname: location.pathname,
						search: queryString.stringify(params),
					});
				}
			}
		};
		
		// Add message listener
		window.addEventListener('message', handleMessage);
		
		// Clean up
		return () => {
			window.removeEventListener('message', handleMessage);
		};
	}, []);

	useEffect(() => {
		setLoader(true);
		dispatch(getDocumentTypeRules(payload, (result) => {
			if (result) {
				setOrgRules(result.documentRules || []);
				setGeneralRules(result.generalRules || []);
				setOrgName(result.orgName || '');
				setDocTypeName(result.docTypeName || '');
			}
			setLoader(false);
		}));
		backendSocket.on(`docassist`, (result) => {
			if (result && result.userId == localStorage.getItem('loggedInOrg')) {
				setSearchQuery('');
				setOrgRules(result.documentRules || []);
				setGeneralRules(result.generalRules || []);
				setOrgName(result.orgName || '');
				setDocTypeName(result.docTypeName || '');
				setPacketId(result?.packetId || '');
				updatePacketId(result?.packetId);
				updateOrgId(result?.orgId)
				const searchParams = new URLSearchParams(window.location.search);
				searchParams.set('packetId', result?.packetId);

				// Update the URL without reloading the page
				history.replace({
					search: searchParams.toString(),
				});
			}
		});

		backendSocket.off("isLogout").on("isLogout", (result) => {
			if (result) {
				if(user._id == result?.data) {
					localStorage.removeItem(DocAssistWindowManager.WINDOW_KEY);
					window.close();
				}
			}
		});
	}, []);

	const fetchRules = (updatedPayload) => {
		dispatch(getDocumentTypeRules(updatedPayload, (result) => {
			if (result) {
				setOrgRules(result.documentRules || []);
				setGeneralRules(result.generalRules || []);
				setOrgName(result.orgName || '');
				setDocTypeName(result.docTypeName || '');
			}
		}));
	};

	const handleSearchChange = (e) => {
		setSearchQuery(e.target.value);
	};

	const handleApplyClick = () => {
		const updatedPayload = { organization: orgId, docType: packetId, keyword: searchQuery };
		fetchRules(updatedPayload);
	}
	
	const handleClearClick = () => {
		const updatedPayload = { organization: orgId, docType: packetId, keyword: '' };
		setPayload(updatedPayload);
		setSearchQuery('');
		fetchRules(updatedPayload);
	};

	// Rest of the component...
	return (
		// Your existing JSX
		<div style={{ marginLeft: "25px", marginTop: "15px" }}>
			{/* Document Name */}
			<div style={{ marginBottom: "20px" }}>
				{/* Document Name */}
				<div style={{ marginBottom: '10px' }}>
					<span>
						<strong>Document Name :</strong> {docTypeName}
					</span>
				</div>

				{/* Search Bar and Buttons */}
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<div style={{ width: "250px", marginRight: '10px' }}>
						<Input
							type="text"
							placeholder="Search rules..."
							value={searchQuery}
							onChange={handleSearchChange}
						/>
					</div>
					<Button
						onClick={handleApplyClick}
						style={{ padding: '9px 20px', marginRight: '10px' }}
					>
						APPLY
					</Button>
					<Button color="link" onClick={handleClearClick} className="clear-btn d-inline-flex align-items-center" style={{ padding: '0px' }}>
						<span className="icon d-inline-flex">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="30"
								height="30"
								viewBox="0 0 34 34"
							>
								<g data-name="Group 651" transform="translate(-1535 -134)">
									<g
										fill="#fff"
										stroke="#000"
										strokeWidth="2"
										data-name="Ellipse 30"
										opacity="0.3"
										transform="translate(1535 134)"
									>
										<circle cx="17" cy="17" r="17" stroke="none"></circle>
										<circle cx="17" cy="17" r="16" fill="none"></circle>
									</g>
									<path
										d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
										data-name="Icon ionic-ios-close"
										opacity="0.3"
										transform="translate(1534.289 132.789)"
									></path>
								</g>
							</svg>
						</span>
						<span className="proper" > Clear Filters</span>
					</Button>
				</div>
			</div>

			{/* Organization-Specific Rules */}
			<div style={{ marginBottom: "20px" }}>
				{orgName ? <h4>{orgName} :</h4> : null}
				{orgRules.length ? (
					<ul>
						{(
							orgRules.map((rule, index) => (
								<li key={index}>
									<strong>{rule.ruleTitle}</strong>
									<span style={{ marginLeft: '10px' }}>
										(Effective Date: {moment.utc(rule.ruleEffectiveDate).format('MM/DD/YYYY')})
									</span>
									<div style={{ marginTop: '5px', marginLeft: '15px' }}>
										<span dangerouslySetInnerHTML={{ __html: rule.ruleDescription }} />
									</div>
								</li>
							)))}
					</ul>
				) : !loader ? (
					<li>No organization-specific rules available.</li>
				) : null}
			</div>

			{/* General Rules */}
			<div>
				{orgName ? <h4>General Rules :</h4> : null}
				{generalRules.length ? (
					<ul>
						{(generalRules.map((rule, index) => (
							<li key={index}>
								<strong>{rule.ruleTitle}</strong>
								<span style={{ marginLeft: '10px' }}>
									(Effective Date: {moment.utc(rule.ruleEffectiveDate).format('MM/DD/YYYY')})
								</span>
								<div style={{ marginTop: '5px', marginLeft: '15px' }}>
									<span dangerouslySetInnerHTML={{ __html: rule.ruleDescription }} />
								</div>
							</li>
						)))}
					</ul>
				) : !loader ? (
					<li>No general rules available.</li>
				) : null}
			</div>
		</div>
	);
};

export default DocAssistRules;